import { IGrid } from "../../models/Grid";
import getAllClues from "./getAllClues";

function getRevealedClues(grid: IGrid) {
  return getAllClues(grid).filter((clue) => clue.isRevealed);
}

export default getRevealedClues;
